import { filterNilValue } from "@datorama/akita";
import { getTypedContext } from "@lib/svelte-typed-context";
import { DISCOUNT_COOKIE_KEY } from "@modules/nudges/constants";
import { nudgesContextToken } from "@modules/nudges/context_tokens";
import Cookies from "js-cookie";
import { BehaviorSubject, lastValueFrom, switchMap } from "rxjs";

export const nudgesCustomerRewardsState = () => {
    const {
        cartService,
        locationController,
        shopifyDiscountApiService,
        urlsBuilder,
        nudgesService,
        nudgesQuery,
        NudgesPopUpWidgetVisibilityManager,
        cartQuery,
        localizationInfoProvider,
    } = getTypedContext(nudgesContextToken);

    const locale = localizationInfoProvider.getGwI18nLocale();

    const nudges$ = nudgesQuery.nudges$;

    //State
    const checkoutItem$ = new BehaviorSubject<{
        variantId: number;
        rewardItemId: number;
    }>({
        variantId: 0,
        rewardItemId: 0,
    });

    const isDiscountCodeApplied = (discountCode: string): boolean => {
        const discountCodeFromCookie = Cookies.get(DISCOUNT_COOKIE_KEY);

        return discountCodeFromCookie === discountCode;
    };

    const applyDiscountAndAddToCard = async (
        variantId: number,
        discountCode: string,
        rewardItemId: number
    ): Promise<void> => {
        checkoutItem$.next({ variantId, rewardItemId });

        await cartService.getCart();

        const cart = cartQuery.getValue();

        if (!cart.items.find((c) => c.variant_id === variantId)) {
            await cartService.addToCart([
                {
                    variantID: variantId,
                    quantity: 1,
                },
            ]);
        }
        await applyDiscount(discountCode, rewardItemId);
        locationController.goTo(urlsBuilder.createCartUrl());
    };

    const applyDiscount = async (
        discountCode: string,
        rewardItemId: number
    ) => {
        await lastValueFrom(
            shopifyDiscountApiService.applyDiscount(discountCode, rewardItemId)
        );
        NudgesPopUpWidgetVisibilityManager.nudgesPopUpWidgetHide();
    };

    const cartStatus$ = checkoutItem$.pipe(
        filterNilValue(),
        switchMap((checkoutItem) => {
            return cartQuery.selectEditItemStatus(checkoutItem.variantId);
        })
    );

    return {
        nudges$,
        nudgesService,
        NudgesPopUpWidgetVisibilityManager,
        locationController,
        cartStatus$,
        locale,
        applyDiscount,
        applyDiscountAndAddToCard,
        isDiscountCodeApplied,
    };
};
